import { SortOrder } from "../sort-order";

export class DefaultMeasurementTypeFilters {
  sensor: string;
  unit: string;
  dataType: string;
  sortField: string;
  sortOrder: SortOrder;
}
